// The build (build.mjs / vitest config) replaces `__AHI_BANNER_VERSION__` with a
// string literal at bundle time. `typeof` guards the case where it was never
// defined (e.g. a raw `tsc` type-check) so referencing it can never throw at runtime.
declare const __AHI_BANNER_VERSION__: string;

export const VERSION: string =
  typeof __AHI_BANNER_VERSION__ !== "undefined" ? __AHI_BANNER_VERSION__ : "0.0.0-dev";
